<template>
  <div class="pcn__product-wrapper">
    <div ref="galleryRef" class="pcn__images">
      <div class="pcn__slide-wrapper">
        <div v-for="(image,index) in productImages" :key="index" class="pcn__slide">
          <ImageField 
            :key="image.src"
            class="pcn__image"
            :obj="{'url':image.src,'alt':image.alt,'width':1248,'height':1280}" 
            :load="true"
          /> 
        </div>
      </div>
      <div class="pcn__nav pcn__prev">
        <svg class="pcn__prev-icon">
          <use xlink:href="#icon-arrow-right-white"></use>
        </svg>
      </div>
      <div class="pcn__nav pcn__next">
        <svg class="pcn__next-icon">
          <use xlink:href="#icon-arrow-right-white"></use>
        </svg>
      </div>
    </div>
    <div class="pcn__info">
      <div class="pcn__swatches">
        <div
          v-for="(value,name) in renderColorOptions" :key="name"
          :class="['pcn__swatch', {'active': name === selectedColor}]"
          @click="e => switchActiveSwatch(e, name)"
        >
          <ImageField v-if="value.image" class="pcn__swatchImage" :obj="{'url':value.image.src,'alt':value.image.alt, 'width':38,'height':38}" :isLoadingLazy="isLoadingLazy"/>
        </div>
      </div>
      <div class="pcn__content">
        <div class="pcn__inner-content">
          <span class="pcn__product-title">{{ product.title }}</span>
          <span class="pcn__selected-color">{{ selectedColor }}</span>
          <a :href="`/products/${product.handle}?color=${selectedColor}`" class="pcn__cta">Shop Now</a>
        </div>
        <ImageField v-if="product.awardIcon" class="pcn__awardIcon" :obj="{'url':product.awardIcon,'alt':'Award Icon ', 'width':95,'height':80}"/>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, onBeforeMount, reactive, onMounted, onUpdated } from 'vue';
  import ImageField from '../global/image.vue';
  import Swiper from 'swiper';
  import SwiperCore, { Navigation, EffectFade, Thumbs, A11y } from 'swiper/core';
  
  SwiperCore.use([Navigation,EffectFade,Thumbs,A11y]);

  const props = defineProps({
    product: {
      type: Object,
      required: true,
    },

    isLoadingLazy:{
      type: Boolean,
      default: false
    }
  })

  const { product } = toRefs(props)

  var firstKeyName = reactive(product.value.options[0].name)
  var selectedColor = ref(null)
  var galleryRef = ref(null)
  var gallerySwiper = ref(null)

  onBeforeMount(() => {
    initialSetup();
  })

  onMounted(() =>{
    gallerySwiper.value = new Swiper(galleryRef.value, galleryCarousel.value)
  })

  onUpdated(() => {
    setTimeout(() => {
      gallerySwiper.value.destroy()
      gallerySwiper.value = new Swiper(galleryRef.value, galleryCarousel.value)
    },100)
  })

  const productImages = computed (() => {
    const { images } = product.value;

    const selectedColorImages = images.filter(image => {
      const alt = image.alt.toLowerCase();
      return alt && alt.includes(selectedColor.value?.toLowerCase()) && !alt.includes('swatch') && alt.includes('figmentlp');
    });

    const nonColorImages = images.filter(image => {
      const alt = image.alt.toLowerCase();
      return alt && !alt.includes('swatch');
    });

    let imageData = selectedColor.value ? selectedColorImages : nonColorImages;

    return imageData;
  })

const galleryCarousel = computed(() => {
  return {
    slidesPerView: 1,
    wrapperClass: 'pcn__slide-wrapper',
    slideClass: 'pcn__slide',
    loop: true,
    navigation: {
      nextEl: '.pcn__next',
      prevEl: '.pcn__prev',
    },
    a11y: {
      enabled: true
    }
  }
})

  const renderColorOptions = computed(() => {
    const {variants,tags,images,available} = product.value;

    const firstLevelKeys = variants.reduce((set, variant) => {
      const property = variant.option1;
      const setItem = set[property] = set[property] || { items: [] }
      setItem.items.push(variant)
      if(variant.available) setItem.items.available = true
      return set
    }, {});

    Object.entries(firstLevelKeys).forEach(([key, value]) =>{
      const isAvailable = value.items.available;
      const bisData = tags.filter(tag => tag.toLowerCase().includes(`bis: ${key.toLowerCase()}`))
      
      if (isAvailable || bisData.length || !available) {
        value.image = images.filter(image => {
          const alt = image.alt.toLowerCase()
          return alt.includes(key.toLowerCase()) && alt.includes('swatch')
        })[0]
        value.price = Number(value.items[0].price/100)
        value.comparePrice = Number(value.items[0].compare_at_price/100)
      }else{ 
        delete firstLevelKeys[key]
      }  
    });
    return firstLevelKeys
  })

  const initialSetup = () => {
    if(renderColorOptions.value && firstKeyName === 'Color'){
      selectedColor.value = Object.keys(renderColorOptions.value)[0];
    } 
  }

  const switchActiveSwatch = (e,name) => {
    e.preventDefault();
    selectedColor.value = name;
  }
</script>